import {PageSpinner} from '@/components/shared/PageSpinner'

interface LoadingStateProps {
    message?: string
}

export function LoadingState({message}: LoadingStateProps) {
    return (
        <div data-testid="loading-state">
            <PageSpinner/>
            {message && (
                <p className="text-center text-muted-foreground text-sm mt-2" data-testid="loading-message">
                    {message}
                </p>
            )}
        </div>
    )
}
